import React from 'react';
import { useTranslation } from 'react-i18next';

import { Icon } from '../../../../components';
import { artStyleLabel, useActiveArtStyle } from '../../useActiveArtStyle';
import { Chip, Label, Name } from './ArtStyleChip.styles';

export type ArtStyleChipProps = {
  className?: string;
};

/**
 * "Art style: <name>" on a generate sheet, shown only while the brand has an ACTIVE art style, which spark then
 * adds (its text and its reference images) to what this sheet generates. Informational, not a link: leaving would drop the draft prompt.
 */
export const ArtStyleChip = ({ className }: ArtStyleChipProps): React.ReactElement | null => {
  const { t } = useTranslation();
  const active = useActiveArtStyle();
  if (!active) return null;
  const name = artStyleLabel(active.name) || t('Your art style');
  return (
    <Chip className={className} title={t('New images follow your art style. Manage it on the Art Style tab.')}>
      <Icon name="palette" size={13} />
      <Label>
        {t('Art style:')} <Name>{name}</Name>
      </Label>
    </Chip>
  );
};

export default ArtStyleChip;
